<script>
import { BModal } from 'bootstrap-vue'
import {ProductCategorySelect} from "@core/components/product";
export default {
    components: {ProductCategorySelect, BModal},
    props: {
        onlySelectable: {
            default: false
        },
        selectedItems: {
            default() {
                return [];
            }
        }
    },
    methods: {
        show() {
            this.$refs.productCategorySelectModal.show();
        }
    }
}
</script>

<template>
    <b-modal
        ref="productCategorySelectModal"
        cancel-variant="outline-secondary"
        centered
        size="xl"
        hide-footer
    >
        <ProductCategorySelect
            border
            :only-selectable="onlySelectable"
            :selected-items="selectedItems"
            @change="(data) => $emit('input', data.idList)"
        />
    </b-modal>
</template>

<style scoped lang="scss">

</style>
